import * as React from 'react'
import * as R from 'ramda'
import {ProductFinderAction} from './ProductFinderActions'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import Tabs from 'material-ui/Tabs/Tabs'
import Tab from 'material-ui/Tabs/Tab'
import {ProductFinderState} from './ProductFinderState'
import List from 'material-ui/List'
import ListItem from 'material-ui/List/ListItem'

export function ProductFinderView({state, dispatch}: {
    readonly state: ProductFinderState,
    readonly dispatch: (action: ProductFinderAction) => void,
}) {
    return (
        <Dialog
            title="Produktreferenz hinzufügen"
            modal={false}
            open={true}
            actions={[
                <FlatButton
                    label="Abbrechen"
                    primary={true}
                    onTouchTap={() => dispatch({type: 'Cancel'})}
                    key="cancel"
                />,
            ]}
            onRequestClose={() => dispatch({type: 'Cancel'})}
        >
            <Tabs>
                <Tab label="Vorhandenes Produkt">
                    <div style={{width: '100%'}}>
                        <TextField
                            floatingLabelText="Nach einem Produkt suchen..."
                            value={state.productSearch}
                            onChange={(event, value) => dispatch({
                                type: 'ProductSearchChanged',
                                value,
                            })}
                        />
                        <h5 style={{marginBottom: '0.5em'}}>Vorschläge:</h5>
                        <List style={{height: '200px', overflow: 'auto'}}>
                            {R.map(
                                productWithPriceDefinitions => (
                                    <ListItem
                                        key={productWithPriceDefinitions.product.productId}
                                        onTouchTap={() => dispatch({
                                            type: 'SelectProduct',
                                            productWithPriceDefinitions,
                                        })}
                                    >
                                        {productWithPriceDefinitions.product.name}
                                    </ListItem>
                                ),
                                state.productSuggestions,
                            )}
                        </List>
                    </div>
                </Tab>
                <Tab label="Produktkalkulation">
                    <div>
                        Hier wird es möglich sein, Produktkalkulationen zu
                        erstellen
                    </div>
                </Tab>
            </Tabs>
        </Dialog>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/ProductFinder/ProductFinderView.tsx